import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const inp = "w-full h-11 bg-[#0D0D11] border border-[#D4AF37]/20 px-3 text-sm text-[#F5F3EF] focus:outline-none focus:border-[#D4AF37]";
const lbl = "block font-mono-j text-[11px] uppercase tracking-[0.18em] text-[#A09E97] mb-1.5";
const card = "border border-[#D4AF37]/20 bg-[#13141C] p-6 sm:p-8";

export const AccountSettings = () => {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState(user.email);
  const [pw, setPw] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(null);

  const save = async (payload, what, form) => {
    setBusy(what);
    try {
      const { data } = await api.patch("/auth/me", payload);
      setUser((u) => ({ ...u, email: data.email }));
      toast.success(what === "email" ? `Login email changed to ${data.email}` : "Password updated");
      setPw({ current: "", next: "", confirm: "" });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setBusy(null); }
  };

  const changeEmail = (e) => {
    e.preventDefault();
    save({ email, current_password: pw.current }, "email");
  };
  const changePassword = (e) => {
    e.preventDefault();
    if (pw.next !== pw.confirm) return toast.error("New passwords don't match");
    save({ new_password: pw.next, current_password: pw.current }, "password");
  };

  return (
    <div className="grid lg:grid-cols-2 gap-8" data-testid="account-settings">
      <form onSubmit={changeEmail} className={card}>
        <h3 className="font-display text-2xl text-[#F5F3EF]">Login email</h3>
        <p className="mt-2 text-sm text-[#A09E97]">The address you sign in to the admin with. Quote and sample requests still go to the sales inbox.</p>
        <div className="mt-6 space-y-4">
          <div><label className={lbl}>Email</label><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inp} data-testid="account-email" /></div>
          <div><label className={lbl}>Current password</label><input type="password" required value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} className={inp} data-testid="account-email-current-password" autoComplete="current-password" /></div>
        </div>
        <button disabled={busy === "email" || email.trim().toLowerCase() === user.email} data-testid="account-email-save"
          className="mt-6 h-11 px-7 rounded-full bg-[#D4AF37] text-[#0D0D11] text-sm font-medium hover:bg-[#E5C158] disabled:opacity-50 transition-colors">
          {busy === "email" ? "Saving…" : "Change email"}
        </button>
      </form>

      <form onSubmit={changePassword} className={card}>
        <h3 className="font-display text-2xl text-[#F5F3EF]">Password</h3>
        <p className="mt-2 text-sm text-[#A09E97]">At least 10 characters.</p>
        <div className="mt-6 space-y-4">
          <div><label className={lbl}>Current password</label><input type="password" required value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} className={inp} data-testid="account-pw-current" autoComplete="current-password" /></div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className={lbl}>New password</label><input type="password" required minLength={10} value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} className={inp} data-testid="account-pw-new" autoComplete="new-password" /></div>
            <div><label className={lbl}>Confirm</label><input type="password" required minLength={10} value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} className={inp} data-testid="account-pw-confirm" autoComplete="new-password" /></div>
          </div>
        </div>
        <button disabled={busy === "password"} data-testid="account-pw-save"
          className="mt-6 h-11 px-7 rounded-full border border-[#D4AF37]/50 text-[#E5C158] text-sm hover:bg-[#D4AF37]/10 disabled:opacity-50 transition-colors">
          {busy === "password" ? "Saving…" : "Change password"}
        </button>
      </form>
    </div>
  );
};
